/**
 * Created by TF on 2018/6/20
 */
import axios from 'axios'
let qs = require('qs');

let base = 'http://47.104.248.56:8081';

var instance = axios.create({
  headers: {
    // 'content-type': 'application/json',
    'Authorization': ''
  }
});

instance.interceptors.request.use(
  config => {
    config.headers.Authorization = sessionStorage.getItem('Authorization');
    return config
  }, err => {
    return Promise.reject(err)
  });

// 借入项目查询：
export const reqBorrowProjectListPage = params => {
  return instance.get(`${base}/borrowProject/list`, {params: params})
};
// 借入项目添加
export const reqAddBorrowProject = params => { return instance.post(`${base}/borrowProject/add`, qs.stringify(params) ) };

// 借入项目编辑
export const reqEditBorrowProject = params => { return instance.post(`${base}/borrowProject/edit`, qs.stringify(params)) };

// 借入项目删除
export const reqDeleteBorrowProject = params => {
  return instance.delete(`${base}/borrowProject/delete/` + params.id, params)
};
// 借入项目批量删除
export const reqBatchDeleteBorrowProject = params => {
  return instance.post(`${base}/borrowProject/batchdelete`, params)
};

// 借入项目通过项目id查询项目
export const reqGetOneBorrowProject = params => {
  return instance.get(`${base}/borrowProject/one`, {params: params})
};
// 借入项目个数
export const reqGetBorrowProjectCounts = params => {
  return instance.get(`${base}/borrowProject/counts`, {params: params})
};
// 借入项目 热点列表
export const reqGetTopNBorrowProjects = params => {
  return instance.get(`${base}/borrowProject/queryTopNList`, {params: params})
};

// 查询资讯中心中案例展示的总条数
export const reqGetCaseShowCount = params => {
  return instance.get(`${base}/borrowProject/caseShowCount`, {params: params})
};


// 出借项目查询：
export const reqLoanProjectListPage = params => {
  return instance.get(`${base}/loanProject/list`, {params: params})
};
// 出借项目添加
export const reqAddLoanProject = params => { return instance.post(`${base}/loanProject/add`, qs.stringify(params) ) };

// 出借项目编辑
export const reqEditLoanProject = params => { return instance.post(`${base}/loanProject/edit`, qs.stringify(params)) };

// 出借项目删除
export const reqDeleteLoanProject = params => {
  return instance.delete(`${base}/loanProject/delete/` + params.id, params)
};
// 出借项目批量删除
export const reqBatchDeleteLoanProject = params => {
  return instance.post(`${base}/loanProject/batchdelete`, params)
};

// 出借项目通过项目id查询项目
export const reqGetOneLoanProject = params => {
  return instance.get(`${base}/loanProject/one`, {params: params})
};
// 出借项目个数
export const reqGetLoanProjectCounts = params => {
  return instance.get(`${base}/loanProject/counts`, {params: params})
};
// 出借项目 热点列表
export const reqGetTopNLoanProjects = params => {
  return instance.get(`${base}/loanProject/queryTopNList`, {params: params})
};


// 债权转让查询：
export const reqAssignmentDebtListPage = params => {
  return instance.get(`${base}/assignmentDebt/list`, {params: params})
};
// 债权转让添加
export const reqAddAssignmentDebt = params => { return instance.post(`${base}/assignmentDebt/add`, qs.stringify(params) ) };

// 债权转让编辑
export const reqEditAssignmentDebt = params => { return instance.post(`${base}/assignmentDebt/edit`, qs.stringify(params)) };

// 债权转让删除
export const reqDeleteAssignmentDebt = params => {
  return instance.delete(`${base}/assignmentDebt/delete/` + params.id, params)
};
// 债权转让批量删除
export const reqBatchDeleteAssignmentDebt = params => {
  return instance.post(`${base}/assignmentDebt/batchdelete`, params)
};

// 债权转让通过项目id查询项目
export const reqGetOneAssignmentDebt = params => {
  return instance.get(`${base}/assignmentDebt/one`, {params: params})
};
// 债权转让项目个数
export const reqGetAssignmentDebtCounts = params => {
  return instance.get(`${base}/assignmentDebt/counts`, {params: params})
};

export const editorUploadFileURL = `${base}/editorFile/uploadFile/`;

// 验证用户登录状态
export const reqValidateWebUser = params => { return instance.get(`${base}/validateWebUser`, { params: params }) };





// WEBPACK FOOTER //
// ./src/api/projectManagement-api.js